export const createTypeTabs = [
  { title: 'myTenders.youCreated', key: 'ME' },
  { title: 'myTenders.colleagues', key: 'COLLEAGUE' },
];

export const statusTabs = [
  { title: 'myTenders.active', key: ['OPEN_FOR_BID', 'PUBLISHED'] },
  {
    title: 'myTenders.forApprove',
    key: ['ON_APPROVAL', 'ON_APPROVAL_UNSUCCESSFUL'],
  },
  { title: 'myTenders.onModeration', key: ['ON_MODERATION'] },
  { title: 'myTenders.drafts', key: ['DRAFT', 'ON_REVISION'] },
  { title: 'myTenders.all', key: [] },
];
